import { SacChamado } from "@/types/Chamados";
import { useState } from "react";

export type ChamadoStep = "list" | "detail" | "response" | "rating" | "thanks";

export interface ChamadosStepsState {
  currentStep: ChamadoStep;
  selectedChamado: SacChamado | null;
  showResponseForm: boolean;
  rating: number | null;
}

export function useChamadosSteps() {
  const [state, setState] = useState<ChamadosStepsState>({
    currentStep: "list",
    selectedChamado: null,
    showResponseForm: false,
    rating: null,
  });

  const goToList = () => {
    setState({
      currentStep: "list",
      selectedChamado: null,
      showResponseForm: false,
      rating: null,
    });
  };

  const goToDetail = (chamado: SacChamado) => {
    setState((prev) => ({
      ...prev,
      currentStep: "detail",
      selectedChamado: chamado,
      showResponseForm: false,
    }));
  };

  const toggleResponseForm = () => {
    setState((prev) => ({
      ...prev,
      showResponseForm: !prev.showResponseForm,
    }));
  };

  const goToRating = () => {
    setState((prev) => ({
      ...prev,
      currentStep: "rating",
      showResponseForm: false,
    }));
  };

  const goToThanks = (rating: number) => {
    setState((prev) => ({
      ...prev,
      currentStep: "thanks",
      rating,
    }));
  };

  return {
    ...state,
    goToList,
    goToDetail,
    toggleResponseForm,
    goToRating,
    goToThanks,
  };
}
